module.exports = __webpack_public_path__ + "static/mapa_OJPIII_poziom-07c62846afa51c3453478c4b41972e97.png";